export const theme = {
  colors: {
    primary: '#29355A',
    secondary: '#85C7F2',
    gray: '#A4A9AD',
    active: '#2b9af3',
    disabled: '#d2d2d2',
    warning: '#F0AB00',
    error: '#FF0000',
    success: '#178C26',
    up: '#0066CC',
    over: '#004080',
  },
  // making the breakpoints match the responsive sizes in the chromium debugger
  breakpoints: {
    xs: '0',
    sm: '425px',
    md: '768px',
    lg: '1024px',
    xl: '1440px',
  },
}
